/// <reference types="./publishedSearchEntities.d.ts" />
import { ok, } from '@dossierhq/core';
import { authResolveAuthorizationKeys } from '../Auth.js';
import { decodePublishedEntity } from '../EntityCodec.js';
import { fetchAndDecodeConnection } from '../utils/fetchAndDecodeConnection.js';
export async function publishedSearchEntities(schema, publishedSchema, authorizationAdapter, databaseAdapter, context, query, paging) {
    const authKeysResult = await authResolveAuthorizationKeys(authorizationAdapter, context, query?.authKeys);
    if (authKeysResult.isError())
        return authKeysResult;
    const authKeys = authKeysResult.value;
    if (authKeys.length === 0) {
        // User requested with authKeys, but they resolved to nothing, so we won't match any entity
        return ok(null);
    }
    return fetchAndDecodeConnection(paging, (pagingInfo) => databaseAdapter.publishedEntitySearchEntities(publishedSchema, context, query, pagingInfo, authKeys), (edge) => decodePublishedEntity(schema, edge));
}
//# sourceMappingURL=publishedSearchEntities.js.map